export const iconFontAwesomeHumanitarianSchoolFlag = (
	<i className="fa-solid fa-school-flag"></i>
);
